module.exports = __webpack_public_path__ + "static/media/ThumbsUp.3cabd76c.svg";